var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconXSignCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4169 5.58295C10.7098 5.87584 10.7098 6.35072 10.4169 6.64361L6.64361 10.4169C6.35072 10.7098 5.87584 10.7098 5.58295 10.4169C5.29006 10.1241 5.29006 9.64918 5.58295 9.35628L9.35628 5.58295C9.64918 5.29006 10.1241 5.29006 10.4169 5.58295Z",
    className: "icon-fill"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58295 5.58295C5.87584 5.29006 6.35072 5.29006 6.64361 5.58295L10.4169 9.35628C10.7098 9.64918 10.7098 10.1241 10.4169 10.4169C10.1241 10.7098 9.64918 10.7098 9.35628 10.4169L5.58295 6.64361C5.29006 6.35072 5.29006 5.87584 5.58295 5.58295Z",
    className: "icon-fill"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.75C4.54788 1.75 1.75 4.54788 1.75 8C1.75 11.4521 4.54788 14.25 8 14.25C11.4521 14.25 14.25 11.4521 14.25 8C14.25 4.54788 11.4521 1.75 8 1.75ZM0.25 8C0.25 3.71945 3.71945 0.25 8 0.25C12.2805 0.25 15.75 3.71945 15.75 8C15.75 12.2805 12.2805 15.75 8 15.75C3.71945 15.75 0.25 12.2805 0.25 8Z",
    className: "icon-fill"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconXSignCircle);
export default __webpack_public_path__ + "static/media/icon-x-sign-circle.cef16d66058436b09924163bb8f3c658.svg";
export { ForwardRef as ReactComponent };